<template>
    <div class="flex column" style="width: 100vm" v-title data-title="关于班级">
      <div v-for="(data, index) in list" :key="index">
        <div class="flex column" style="height: 49px; margin: 0 16px" @click="$router.push({name:'QuestionDetail', params: {question: JSON.stringify(data)}})">
          <div class="flex main-space-between cross-center" style="height: 49px;">
            <span>{{index + 1}}.{{data.title}}</span>
            <img src="../assets/arrow_right.png" style="width: 7px; height: 13px">
          </div>
          <div style="background: #EEEEEEFF; height: 1px; width: 100%"></div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "AboutClass",
      data () {
          return{
            list: [
              {
                title: '班级是什么？',
                detailTexts: [{title: '阅伴App中的班级是由老师创建，并组织学生阅读学习的线上功能。'}]
              },
              {
                title: '如何创建班级？',
                detailTexts: [{title: '教师认证通过后，打开“阅伴教师端App”-“首页"，点击创建班级，根据流程操作即可。'}]
              },
              {
                title: '如何邀请我的学生加入班级？',
                detailTitle: '邀请学生加入班级的方法如下：',
                detailTexts: [{title: '1.将班号告诉学生，学生在“阅伴学生端”搜索班号加入。'},
                  {title: '2.进入班级，点击“邀请学生"按钮，通过分享链接的方式，将链接推送给学生，邀请学生加入班级。'}]
              },
              {
                title: '学生进入班级是否需要审核？',
                detailTexts: [{title: '学生加入班级，需要老师在阅伴教师端App中审核通过，通过后学生即可加入班级。'}]
              },
              {
                title: '什么是阅读任务？如何发布阅读任务？',
                detailTexts: [
                  {title: '阅读任务，是老师给学生布置的阅读作业。'},
                  {title: '同一个班级可以有3个同时进行中的任务，每个任务可以发布1至6本书。在发布任务的时可设置时间，如未设置时间，那么此任务默认时间限制为6个月。'},
                  {title: '发布任务的方法，打开阅伴教师端，进入班级，点击“发布任务”，根据流程完成即可。'}
                ]
              },
              {
                title: '发布任务后，如何查看全班的阅读情况？',
                detailTexts: [{title: '进入班级，点击“查看榜单”按钮，进入任务详情页，可查看全班学生的阅读情况和数据。参见下图：', img: require('../assets/class_task_list.png')}]
              },
              {
                title: '发布任务后，如何查看单个学生的阅读情况？',
                detailTexts: [{title: '进入任务详情页后，找到想要查看的学生，点击该学生右侧的“查看”按钮，然后点击详细数据，参见下图：', img: require('../assets/class_task_student.png')}]
              },
              {
                title: '任务中学生的排名是怎么统计的？',
                detailTexts: [{title: '在正序条件下，学生排名是以完成闯关的数量进行排名的，如果闯关数量一样，会根据平均正确率排名，如果闯关数量、平均正确率一样，会根据闯关次数排名。完成关数量越多、平均正确率越高、闯关次数越少，排名会越靠前。'}]
              },
              {
                title: '如何移除班级内的学生？',
                detailTexts: [{title: '进入班级，点击“学生管理”，参见下图', img: require('../assets/class_task_stu_manage.png')},
                  {title: '进入到学生列表，然后点击“删除”，勾选要删除的学生，点击删除即可，参见下图：', img: require('../assets/class_task_stu_remove.png')}]
              },
              {
                title: '如何提前结束阅读任务？',
                detailTexts: [{title: '进入班级，找到想要提前结束的阅读任务，点击“查看榜单”，进入任务详情页，点击右上角的“任务管理”，选择“提前结束”即可。'}]
              },
              {
                title: '如何修改阅读任务？',
                detailTexts: [{title: '进入班级，找到想要修改的阅读任务，点击“查看榜单”，进入任务详情页，点击右上角的“任务管理”，选择“修改任务”即可。'}]
              },
              {
                title: '修改任务，可以更换布置的图书吗？',
                detailTexts: [{title: '修改阅读任务，仅可修改任务名称、任务说明、任务时限，发布的图书任务是，不能修改的。'},
                  {title: '如果想更换布置的图书，建议重新发布一次任务。'}]
              },
              {
                title: '如何删除阅读任务？',
                detailTexts: [{title: '进入班级，找到想要删除的阅读任务，点击“查看榜单”，进入任务详情页，点击右上角的“任务管理”，选择“删除任务”即可。'}]
              },
              {
                title: '如何修改班级信息？',
                detailTexts: [{title: '进入班级，点击右上角的班级管理，点击“修改班级信息”即可。'}]
              },
              {
                title: '如何解散班级？',
                detailTexts: [{title: '进入班级，点击右上角的班级管理，点击“解散班级”即可。'}]
              },
              {
                title: '如何给学生发放阅芽？',
                detailTexts: [
                  {title: '进入您的班级页面，点击“学生管理”，参见下图：', img: require('../assets/class_task_stu_manage.png')},
                  {title: '进入学生管理页面，点击右上角的发放阅芽，参见下图：', img: require('../assets/class_task_stu_send_yueya.png')},
                  {title: '然后选择，要发放阅芽的学生。发放阅芽可自定义（每个学生发放不同数量的阅芽）、根据人均发放（每个学生发放相同数量的阅芽）。发放的阅芽数量，不能超过老师拥有的阅芽数量。'}]
              },
              {
                title: '如何转让班级？',
                detailTexts: [{title: '进入转让的班级页面，点击右上角的“班级管理”，点击转让班级，然后输入承接班级的教师手机号，等待承接人确认接收即可。承接班级的教师需完成教师认证才可接收班级'}]
              }
            ]
          }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutClass.vue